import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ButtonModule } from '../../../button/button.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';
import { LoadDataFormComponent } from './load-data-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputBoxModule,
    SelectBoxModule,
    ButtonModule,
    BlockModalDragModule,
  ],
  declarations: [LoadDataFormComponent],
  exports: [LoadDataFormComponent],
})
export class LoadDataFormModule {}
